module.exports = __webpack_public_path__ + "img/TC.abb6f012.svg";